'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractAggregations = extractAggregations;
exports.extractHits = extractHits;
exports.extractSource = extractSource;
exports.extractAll = extractAll;
exports.esCleanup = esCleanup;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* There is a weird issue with the next line...
 * `import { isNumeric } from 'bastetjs';`
 * It makes this script run slow. I wasn't able to figure it out, and I hope eventually, this will resolve itself in the future... -G
 */
function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

/* * * If key is an ES agg return the value * * */
function extractAggregations(val, key) {
  return key === 'aggregations' ? val : false;
}

/* * * If key is an ES hits return the value * * */
function extractHits(val, key) {
  return key === 'hits' ? val.hits : false;
}

/* * * If key is an ES _source return the value * * */
function extractSource(val, key) {
  return key === '_source' ? val : false;
}

/* * * Extract all ES values that make things difficulte to navigate * * */
function extractAll(val, key) {
  var aggs = extractAggregations(val, key);
  if (aggs !== false) {
    return aggs;
  }

  var hits = extractHits(val, key);
  if (hits !== false) {
    return hits;
  }

  var source = extractSource(val, key);
  if (source !== false) {
    return source;
  }

  return false;
}

/* Clean up an ES Document to make it managable.
 * This is pretty hacky, I'm pretty sure I could have done a better job.
 * Hopefully documentation is clear enough that it doesn't become a disaster.
 * - - - - - -
 * @param {obj|array} doc
 *
 * @return {obj|array}
 */
function esCleanup(doc) {
  if (doc === null) {
    doc = {};
  }

  // Need to check if the initial document coming in is an object or array.
  var isObj = _lodash2.default.isPlainObject(doc);
  var obj = isObj ? {} : [];

  // If `buckets` is there, I want to overwrite the entire object with it's value.
  if (doc.buckets !== void 0) {
    return esCleanup(doc.buckets);
  }

  // Loop through each item in the document
  _lodash2.default.forEach(doc, function (val, key) {
    // Check for ES value
    var esValue = extractAll(val, key);
    var finalVal = void 0;

    // If key is an es index, we treat it differently
    if (esValue) {
      // Lets do this before I overwrite later.
      var isPlainObject = _lodash2.default.isPlainObject(esValue);

      if (key === 'hits') {
        finalVal = Object.assign({}, finalVal, { total: val.total });
      }

      // If it an object or array, lets go recursive
      if (_lodash2.default.isObject(esValue)) {
        esValue = esCleanup(esValue);
      }

      // Now if a plain object is returned, lets just return that, rather than assigning it to a key.
      finalVal = Object.assign({}, finalVal, isPlainObject ? esValue : _defineProperty({}, key, esValue));
    } else {
      // If it an object or array, lets go recursive
      if (_lodash2.default.isObject(val)) {
        val = esCleanup(val);
      }

      // If the key is numeric, then it's apart of an array.
      finalVal = isNumeric(key) ? val : _defineProperty({}, key, val);
    }

    // Depending on the original object, assign or push value.
    if (isObj) {
      Object.assign(obj, finalVal);
    } else {
      obj.push(finalVal);
    }
  });

  return obj;
}


//////////////////
// WEBPACK FOOTER
// ../~/anuket/lib/esCleanup.js
// module id = 171
// module chunks = 0